import React from 'react';

const WarningV2 = ({
  className,
  style,
  active
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24 4C12.98 4 4 12.98 4 24C4 35.02 12.98 44 24 44C35.02 44 44 35.02 44 24C44 12.98 35.02 4 24 4ZM22.5 16C22.5 15.18 23.18 14.5 24 14.5C24.82 14.5 25.5 15.18 25.5 16V26C25.5 26.82 24.82 27.5 24 27.5C23.18 27.5 22.5 26.82 22.5 26V16ZM25.84 32.76C25.74 33.02 25.6 33.22 25.42 33.42C25.22 33.6 25 33.74 24.76 33.84C24.52 33.94 24.26 34 24 34C23.74 34 23.48 33.94 23.24 33.84C23 33.74 22.78 33.6 22.58 33.42C22.4 33.22 22.26 33.02 22.16 32.76C22.06 32.52 22 32.26 22 32C22 31.74 22.06 31.48 22.16 31.24C22.26 31 22.4 30.78 22.58 30.58C22.78 30.4 23 30.26 23.24 30.16C23.72 29.96 24.28 29.96 24.76 30.16C25 30.26 25.22 30.4 25.42 30.58C25.6 30.78 25.74 31 25.84 31.24C25.94 31.48 26 31.74 26 32C26 32.26 25.94 32.52 25.84 32.76Z",
      fill: "#FF7400"
    }
  )
);

export { WarningV2 };
//# sourceMappingURL=WarningV2.js.map
